import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import { createRoot } from 'react-dom/client';

import * as Sentry from '@sentry/react';

Sentry.init({
  dsn: 'https://8d1e8917cf50251023b9299ce3d88a81@o366933.ingest.us.sentry.io/4508940532973568',
});

const container = document.getElementById('root');
const root = createRoot(container);
root.render(<App />);
